/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();
  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.loginForms();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  });
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};

timber.updateHash = function (hash) {
  window.location.hash = '#' + hash;
  $('#' + hash).attr('tabindex', -1).focus();
};

timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, timber.switchImage);
    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to Cart");
      $quantityElements.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
    }

    // Regardless of stock, update the product price
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

    // Also update and show the product's compare price if necessary
    if (variant.compare_at_price > variant.price) {
      $comparePrice
        .html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
        .show();
    } else {
      $comparePrice.hide();
    }

  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);
    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
};

timber.responsiveVideos = function () {
  $('iframe[src*="youtube.com/embed"]').wrap('<div class="video-wrapper"></div>');
  $('iframe[src*="player.vimeo"]').wrap('<div class="video-wrapper"></div>');
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    this.$nodes.page.off('.drawer');
  };

  return Drawer;
})();

$(function() {

  // Header search
  var $search_trigger = $('#header-search-trigger'),
      $search_close   = $('#header-search-close'),
      $search_overlay = $('#header-search-overlay'),
      $search_input   = $('#header-search-input'),
      search_toggle   = function() {
        if( $search_overlay.is(':hidden') ) {
          $search_overlay.css({ top: $('.nav-bar').height() });
          $search_overlay.fadeIn(200);
          $search_trigger.addClass('active');
          $search_input.focus();
        } else {
          $search_overlay.fadeOut(200);
          $search_trigger.removeClass('active');
        }
      };
  if( $search_trigger.length > 0 ) {
    $search_trigger.click(search_toggle);
    $search_close.click(search_toggle);
  }

  var $header = $('nav.nav-bar'),
      hheight = $header.height(),
      winheight = $(window).height(),
      docheight = $(document).height();
  if( $header.length > 0 && docheight > winheight + hheight ) {
    $header.sticky();
    $header.on('sticky-end', function() {
      // Allow for transitions to finish before we grab new height
      $header.parent().height(hheight);
    });
  }

  // Mobile nav
  var $nav_trigger = $('#mobile-nav-trigger'),
      $nav_overlay = $('#mobile-nav-overlay'),
      $nav_icon = $('i', $nav_trigger),
      nav_toggle   = function() {
        if( $nav_overlay.is(':hidden') ) {
          $nav_overlay.css({ top: $('.nav-bar').height() });
          $nav_overlay.fadeIn(200);
          $nav_trigger.addClass('active');
          $nav_icon.removeClass('fa-bars');
          $nav_icon.addClass('fa-close');
        } else {
          $nav_overlay.fadeOut(200);
          $nav_trigger.removeClass('active');
          $nav_icon.removeClass('fa-close');
          $nav_icon.addClass('fa-bars');
          $nav_trigger.blur();
        }
      };
  if( $nav_trigger.length > 0 ) {
    $nav_trigger.click(nav_toggle);
  }

  // Category Menu
  var category_menu = function() {

    var $category_menu = $('#category-menu-mobile'),
        $open = $('#category-menu-open'),
        $close = $('#category-menu-close');

    var hide_category = function() {
      $category_menu.add($open).removeClass('shown');
    };

    $open.click(function() {
      if( $category_menu.hasClass('shown') ) {
        hide_category();
      } else {
        $category_menu.add($open).addClass('shown');
      }
    });

    $close.click(function() {
      hide_category();
    });

  }();

  // Quick View
  $('.product-quick-view').each( function() {
    var $this = $(this),
        product_handle = $this.attr('data-product-handle');

    var activefancy = $this.fancybox({
        margin: [ 40, 20, 20, 20 ]
    });

  });

  // Newsletter
  $('.newsletter').fancybox({
    preload: true,
    margin: [ 40, 20, 20, 20 ]
  });

  // Countdown
  
  
  

	// Global countdown set with data-attribute
	(function($) {
		$.fn.initCountdown = function() {
			$(this).each(function(index, el) {
				var enddate = $(el).attr('data-countdown-date');
				var fdate = enddate.split(/[^0-9]/);
				var thedate = new Date(Date.UTC(fdate[0], fdate[1]-1, fdate[2], fdate[3], fdate[4], fdate[5]));
				$(el).countdown({
					until: enddate,
					padZeroes: true
				});
			});
			return this;
		};
	})(jQuery);
	$('.thecountdown').initCountdown();
	$('.homepage .main-content').bind('shopify:section:load', function(event) {
		$('.thecountdown').initCountdown();
	});

  // Image Rollovers
  

  // Currency Switcher
  var $currency_selector = $('.currency-selector');
  var $currency_selector_trigger = $('.currency-selector-trigger');
  var $currency_selector_dropdown = $('.currency-selector-dropdown');
  if($currency_selector.length > 0) {
    // Menu functionality
    $currency_selector_trigger.click(function(e) {
      if($currency_selector_dropdown.is(':visible')) {
        $currency_selector.removeClass('shown');
      } else {
        $currency_selector.addClass('shown');
      }
      e.stopPropagation();
    });

    // Make sure link click doesn't close menu
    $currency_selector.click(function(e) {
      e.stopPropagation();
    });

    // Clicking outside of menu closes menu
    $(document).click(function(e) {
      if($currency_selector_dropdown.is(':visible')) {
        $currency_selector.removeClass('shown');
      }
    });
  }

	/*----------------------
	/  Section load events
	/  Until shopify improves the organization of sections, the
	/  section js code will live here.
	/---------------------*/
	window.Sections = window.Sections || {
		Slider: {},
		FeaturedProduct: {}
	};

	//-------------
	// Slider
	//-------------
	Sections.Slider.launchSlider = function(slider) {
		var delay = slider.attr('data-slide-delay');
		slider.bxSlider({
			auto: true,
			autoControls: false,
			pager: false,
			easing: 'ease-in',
			pause: delay
		});
	};

	// Launch existing sliders
	(function loadSliders() {
		var $slider = $('.shopify-section .section-slider');
		var $slider_items = $('.section-slider-item', $slider);
		if( $slider.length > 0 && $slider_items.length > 1 ) {
			Sections.Slider.launchSlider($slider);
		}
	})();

	// Listen when section added in the theme editor
	$('.homepage .main-content').bind('shopify:section:load shopify:section:select', function(event) {
		var $target = $(event.target);
		var $slider = $('.section-slider', $target);
		var $slider_items = $('.section-slider-item', $slider);
		if( $slider.length > 0 && $slider_items.length > 1 ) {
			Sections.Slider.launchSlider($slider);
		}
	});

	//-----------------
	// FeaturdProduct
	//-----------------
	Sections.FeaturedProduct.bindControls = function($fp_container) {

		var product_handle = $fp_container.data('product-handle');
		var settings = $fp_container.data('section-settings');
		var section_id = $fp_container.data('section-id');
		var money_format = $fp_container.data('money-format');

		$.getJSON('/products/' + product_handle + '.js').done(function(product, status) {
			new Shopify.OptionSelectors('productSelect-' + section_id, {
				product: product,
				onVariantSelected: function(variant, selector) {

					var moneyFormat = money_format,
							variant = variant,
							selector = selector;

					// Selectors
					var $productImage = $('.product-single__photos img', $fp_container),
							$addToCart = $('.AddToCart', $fp_container),
							$productPrice = $('.product-price', $fp_container),
							$comparePrice = $('.product-compare-at-price', $fp_container),
							$quantityElements = $('.quantity-selector, label + .js-qty', $fp_container),
							$addToCartText = $('.AddToCartText', $fp_container);

					if (variant) {

						if( settings.fc_countdown_inventory_enabled ) {
							// Update items remaining if enabled
							$('.inventory-quantity', $fp_container).text(variant.inventory_quantity);
						}

						// Update variant image, if one is set
						if (variant.featured_image) {
							//change_image(variant.featured_image);
						}

						// Select a valid variant if available
						if (variant.available) {
							// Available, enable the submit button, change text, show quantity elements
							$addToCart.removeClass('disabled').prop('disabled', false);
							$addToCartText.html('Buy Now');
							$quantityElements.show();
						} else {
							// Sold out, disable the submit button, change text, hide quantity elements
							$addToCart.addClass('disabled').prop('disabled', true);
							$addToCartText.html('Sold Out');
							$quantityElements.hide();
						}

						// Regardless of stock, update the product price
						$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

						// Also update and show the product's compare price if necessary
						if (variant.compare_at_price > variant.price) {
							$comparePrice
								.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat))
								.show();
						} else {
							$comparePrice.hide();
						}

					} else {
						// The variant doesn't exist, disable submit button.
						// This may be an error or notice that a specific variant is not available.
						// To only show available variants, implement linked product options:
						//	 - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
						$addToCart.addClass('disabled').prop('disabled', true);
						$addToCartText.html('Unavailable');
						$quantityElements.hide();
					}
				}
			});

			if( settings.product_advv_enabled == false ) {
				// Add label if only one product option and it isn't 'Title'. Could be 'Size'.
				if( product.options.length === 1 && product.options[0].name !== 'Title' ) {
					$('.selector-wrapper:eq(0)', $fp_container).prepend('<label for="productSelect-option-0">'+product.options[0].name+'</label>');
				}
			}

			// Hide selectors if we only have 1 variant and its title contains 'Default'.
			if( product.variants.length === 1 && product.variants[0].title.indexOf('Default') !== -1 ) {
				$('.selector-wrapper', $fp_container).hide();
			}

			// Ajaxify submission
			$('.AddToCart', $fp_container).click( AddToCart );

			// Setup ajax quantity selectors on the any template if enableQtySelectors is true
			var numInputs = $('input[type="number"]', $fp_container);

			if (numInputs.length) {
				numInputs.each(function() {
					var $el = $(this),
							currentQty = $el.val(),
							inputName = $el.attr('name'),
							inputId = $el.attr('id');

					var itemAdd = currentQty + 1,
							itemMinus = currentQty - 1,
							itemQty = currentQty;

					var source   = $("#JsQty").html(),
							template = Handlebars.compile(source),
							data = {
								id: $el.data('id'),
								itemQty: itemQty,
								itemAdd: itemAdd,
								itemMinus: itemMinus,
								inputName: inputName,
								inputId: inputId
							};

					// Append new quantity selector then remove original
					$el.after(template(data)).remove();
				});

				// Setup listeners to add/subtract from the input
				$('.js-qty__adjust').on('click', function() {
					var $el = $(this),
							id = $el.data('id'),
							$qtySelector = $el.siblings('.js-qty__num'),
							qty = parseInt($qtySelector.val().replace(/\D/g, ''));

					var qty = validateQty(qty);

					// Add or subtract from the current quantity
					if ($el.hasClass('js-qty__adjust--plus')) {
						qty += 1;
					} else {
						qty -= 1;
						if (qty <= 1) qty = 1;
					}

					// Update the input's number
					$qtySelector.val(qty);
				});
			}

			if( settings.fc_countdown_enabled && settings.fc_countdown_end_date != '' && settings.fc_countdown_inventory_enabled == false ) {
				var fdate = settings.fc_countdown_end_date;
				var fdate = fdate.split(/[^0-9]/);
				var thedate = new Date(Date.UTC(fdate[0], fdate[1]-1, fdate[2], fdate[3], fdate[4], fdate[5]));
				$('#thecountdown', $fp_container).countdown({
					until: thedate,
					padZeroes: true
				});
			}

		});

	};
	
	// Listen when section added in the theme editor
	$('.homepage .main-content').bind('shopify:section:load', function(event) {
		var $target = $(event.target);
		var $fp_container = $('.featured-countdown-container', $target);
		if( $fp_container.length > 0 ) {
			Sections.FeaturedProduct.bindControls($fp_container);
		}
	});

	var $fp_container = $('.featured-countdown-container');
	if( $fp_container.length > 0 ) {
		$fp_container.each(function(index, el) {
			Sections.FeaturedProduct.bindControls($(el));
		});
	}

});

window.AddToCart = function(e){
  
  if (typeof e !== 'undefined') e.preventDefault();
  
  var form      = $(this).parents('form');
  var cart_items_max = false;
  var citems = parseInt($('#CartCount').text());
  
  if( !cart_items_max || cart_items_max && citems < cart_items_max ) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: form.serialize(),
      dataType: 'json',
      error: function( jqXHR, textStatus, errorThrown ){
        var response = $.parseJSON(jqXHR.responseText);
        $('.add-to-cart-msg').addClass('error').text(response.description).fadeIn().delay(3000).fadeOut();
      },
      success: function( jqXHR, textStatus, errorThrown ){
        
        $.ajax({
          type: 'GET',
          url: '/cart.js',
          async: false,
          cache: false,
          dataType: 'json',
          success: function(data){$('#CartCount').text(data.item_count);
              timber.RightDrawer.open({ preventDefault: function() {} });
              $.fancybox.close();}
        });
        
      },
      cache: false
    });
  } else {
    $('.add-to-cart-msg').addClass('error').text('You\'ve reached the maximum number of items in the cart.').fadeIn().delay(3000).fadeOut();
  }
  
}

// Initialize Timber's JS on docready
$(timber.init);
